export * from './ProtectionMechanisms'
export * from './ParticipationMechanisms'

export const mechanismItems = {
	'Mecanismos de protección': {
		path: '/sociales/competencias/mecanismos-proteccion',
	},
	'Mecanismos de participación': {
		path: '/sociales/competencias/mecanismos-participacion',
	},
}
